import {Helmet} from '@dr.pogodin/react-helmet';

import {useParams} from 'react-router-dom';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetPromotionalPhotoQuery} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle} from '@dms/shared';

import {PromoPhotosForm} from '../../components/PromoPhotosForm/PromoPhotosForm';

export function PromoPhotoDetail() {
  const {id} = useParams();
  const {data, isLoading} = useGetPromotionalPhotoQuery(
    {promotionalPhotoId: id ?? ''},
    {skip: isNilOrEmpty(id)}
  );

  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          i18n.t('page.salesSettings.labels.editPromoPhoto'),
          i18n.t('page.salesSettings.labels.promotionalPhotos'),
          i18n.t('page.salesSettings.labels.advertising'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate
        header={{
          breadcrumbs: [
            {
              label: i18n.t('page.salesSettings.labels.advertising'),
              href: settingsRoutes.advertising,
            },
            {
              label: i18n.t('page.salesSettings.labels.promotionalPhotos'),
              href: settingsRoutes.advertisingPromoPhotos,
            },
          ],
        }}
        isLoading={isLoading}
        data-testid="settings-advertising-promoPhotos-detail"
      >
        <PromoPhotosForm editData={data} />
      </SettingsTemplate>
    </>
  );
}
